export default __webpack_public_path__ + "static/media/celebration-icon.0d9bb963.svg";